// This icon file is generated automatically.
var PtoKeyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M19 3.5a9.5 9.5 0 00-7.5 15.33L10.2 20.1l-1.94-1.94a.25.25 0 00-.36 0L6.67 19.4c-.1.1-.1.26 0 .36L8.6 21.7l-1.4 1.4-1.95-1.94a.25.25 0 00-.35 0L3.66 22.4c-.1.1-.1.26 0 .36l1.95 1.95-2.04 2.04c-.1.1-.1.25 0 .35l1.32 1.32c.1.1.26.1.35 0l7.93-7.92A9.5 9.5 0 1019 3.5zm5.04 14.54A7.07 7.07 0 0119 20.13c-1.9 0-3.7-.75-5.04-2.1A7.07 7.07 0 0111.87 13c0-1.9.75-3.7 2.1-5.04A7.07 7.07 0 0119 5.88c1.9 0 3.7.74 5.04 2.08A7.07 7.07 0 0126.13 13c0 1.9-.75 3.7-2.1 5.04z", "fill-rule": "nonzero" } }] }, "name": "pto-key", "theme": "outlined" };
export default PtoKeyOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoKeyOutlined.js
// module id = 3911
// module chunks = 0